const ABObjectCore = require("../core/ABObjectCore");
module.exports = class ABObject extends ABObjectCore {};
